var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWear5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5017 26.1278C42.2018 37.8356 54.6824 44.9453 61.5603 32.3874C62.7839 30.1463 62.977 25.7414 65.6561 26.0119C68.6957 26.321 65.7591 30.8418 65.5015 33.0701C64.6128 40.5017 69.4814 43.052 69.9322 47.8304C70.4216 52.8922 68.8889 61.3285 68.5669 66.738C68.0388 75.3031 71.5422 76.4881 61.6762 78.0852C53.2914 79.4376 43.6186 79.2057 35.6717 76.2305C34.9376 70.9497 35.6074 65.5531 35.3626 60.2466C35.2081 56.7561 33.8042 51.1148 34.0231 47.869C34.2163 44.8938 38.0416 41.3132 38.5697 37.3848C39.1236 33.1602 37.4105 30.1077 37.3204 26.0377L40.5146 26.1021L40.5017 26.1278Z",
    fill: "#0256B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWear5);
export default __webpack_public_path__ + "static/media/wear5.d3e77300b4f7c95c37b8af984ec5767b.svg";
export { ForwardRef as ReactComponent };